<template>
  <form 
    :class="[
      `f-form`,
      {
        'is-inline': inline,
      }
    ]"
    @submit.prevent.stop
  >
    <slot 
      :item="item"
    ></slot>
  </form>
</template>

<script>
  import { ref, watch, computed, toRefs } from 'vue'  
  import { useStore } from '@freebe/sdk/store'
  import useStoreItem from '@composables/use-store-item'

  export default {
    props: {
      store: {
        type: [String, null],
        default: null, 
      },

      id: {
        type: [String, Boolean, null],
        default: false,
      },

      local: {
        type: Boolean, 
        default: true,
      },

      inline: {
        type: Boolean,
        default: false,
      },
    },

    setup (props) {
      let item = useStoreItem(props, useStore(props.store))

      return { 
        item,
      }
    },
  }
</script>

<style lang="scss">
  .f-form {
    position: relative;

    & > * {
      margin: 0rem 0.4rem;
    }

    &.is-inline {
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      & > * {
        margin: 0.4rem 0rem;
      }

      & > .f-button[type="submit"] {
        margin: 0.8rem 0rem;
      }
    }
  }
</style>